import { Route, Switch } from "react-router-dom";
import { Chapters } from "../Chapters/Chapters";
import { ReportFrontPage } from "./ReportFrontPage";
import { Chapter } from "../Chapter/Chapter";
import "./Report.css";

export const InternalReport = () => {
    return (
        <Switch>
            <Route
                exact
                path="/figures-and-tables/internal-reports/:reportId/front-page"
                component={ReportFrontPage}
            />
            <Route
                exact
                path="/figures-and-tables/internal-reports/:reportId/table-of-contents"
                component={Chapters}
            />
            <Route
                exact
                path="/figures-and-tables/internal-reports/:reportId/chapters/:chapterId"
                component={Chapter}
            />
        </Switch>
    );
};
